import AppBar from "@mui/material/AppBar"
import Avatar from "@mui/material/Avatar"
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Toolbar from "@mui/material/Toolbar"
import Typography from "@mui/material/Typography"
import { StyledButton } from "components/Button/StyledButton"
import { HelpingDialog } from "components/HelpingDialog/HelpingDialog"
import { User } from "graphql/types"
import { useUserProfile } from "hooks/useUserProfile"
import { JSX, useState } from "react"
import { useNavigate } from "react-router"
import { AppRoutes } from "store/routes"
import { emptyPerson } from "store/store"
import { useLocalStorage } from "utils/useLocalStorage"

const settings = ["Helfen", "Logout"]

export const DashboardHeader = (): JSX.Element => {
  const [, , removeUser] = useLocalStorage<User>("user", emptyPerson)
  const { profilePhotoUrl, displayName, initials, isAuthenticated } = useUserProfile()

  const navigate = useNavigate()
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const [openHelpDialog, setOpenHelpDialog] = useState(false)

  const handleCloseUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    switch (event.currentTarget.textContent) {
      case "Helfen":
        setOpenHelpDialog(true)
        break
      case "Logout":
        removeUser()
        navigate("/")
        break
      default:
        setAnchorElUser(null)
    }
  }

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h5"
            noWrap
            component="a"
            sx={{
              mr: 2,
              flexGrow: 1,
              color: "inherit",
            }}
          >
            Dashboard / Todos
          </Typography>

          <Box sx={{ display: "flex", flexGrow: 0, gap: 2, alignItems: "center" }}>
            <StyledButton
              buttonType="custom"
              onClick={() => navigate(AppRoutes.ADMIN_UI)}
              variant="contained"
            >
              Admin UI
            </StyledButton>

            {/* Display user name */}
            {isAuthenticated && (
              <Typography variant="body1" sx={{ color: "inherit" }}>
                {displayName}
              </Typography>
            )}

            {/* User Avatar Button */}
            {isAuthenticated && (
              <Avatar
                onClick={handleOpenUserMenu}
                src={profilePhotoUrl || undefined}
                sx={{
                  cursor: "pointer",
                  width: 40,
                  height: 40,
                  bgcolor: profilePhotoUrl ? "transparent" : "secondary.main",
                  "&:hover": {
                    bgcolor: profilePhotoUrl ? "rgba(0,0,0,0.1)" : "secondary.dark",
                  },
                }}
              >
                {!profilePhotoUrl && initials}
              </Avatar>
            )}

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: "center" }}>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>

        <HelpingDialog open={openHelpDialog} onClose={() => setOpenHelpDialog(false)} />
      </Container>
    </AppBar>
  )
}
